import React from 'react';
import {
  DtpFormControl,
} from 'dtp-react-components';
import PropTypes from 'prop-types';

const InputText = (props) => {
  if (props.type === 'textarea') {
    return (<textarea
      {...props}
    />);
  }
  return (
    <DtpFormControl
      {...props}
    />
  );
};

InputText.propTypes = {
  // Boolean para ativar a animação no campo
  animate: PropTypes.bool,
  // Desativar input
  disabled: PropTypes.bool,
  // Label que descreve o campo
  label: PropTypes.string.isRequired,
  // Recebe função para o evento de perda de foco (onBlur)
  onBlur: PropTypes.func,
  // Recebe função para o evento de mudança de caracteres no campo
  onChange: PropTypes.func,
  // Tipo de conteúdo a ser inserido no campo
  type: PropTypes.string,
  // Boolean para tornar o campo obrigatório ou não
  required: PropTypes.bool,
  // Estado de validacao
  validationState: PropTypes.string,
  // Valor do input
  value: PropTypes.string,
};

InputText.defaultProps = {
  required: false,
  type: 'text',
  onBlur: null,
  onChange: null,
  animate: false,
  disabled: false,
  validationState: 'null',
  value: '',
};

export default InputText;



// WEBPACK FOOTER //
// ./src/components/ComponentesBasicos/TextInput.jsx